import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faEnvelope,
  faCheck,
  faLock,
  faLockOpen,
  faKey,
  faEdit,
  faSync,
  faArrowCircleUp,
  faArrowCircleDown,
  faPlusCircle,
  faSearch,
  faTriangleExclamation,
  faArrowLeft,
  faArrowRight,
  faStar,
  faDownload,
  faShare,
  faFileExport,
  faFingerprint,
  faCircleNotch,
  faUser,
  faXmark,
  faQrcode,
  faEye,
  faEyeSlash,
  faEllipsisV,
  faWallet,
  faEuroSign,
} from "@fortawesome/free-solid-svg-icons"
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
library.add(
  faEnvelope,
  faCheck,
  faLock,
  faLockOpen,
  faKey,
  faEdit,
  faSync,
  faArrowCircleUp,
  faArrowCircleDown,
  faPlusCircle,
  faSearch,
  faTriangleExclamation,
  faArrowLeft,
  faArrowRight,
  faStar,
  farStar,
  faDownload,
  faShare,
  faFileExport,
  faFingerprint,
  faCircleNotch,
  faUser,
  faXmark,
  faQrcode,
  faEye,
  faEyeSlash,
  faEllipsisV,
  faWallet,
  faEuroSign
)

export default FontAwesomeIcon
